import React from "react";
import "../doortodoor/DoorToDoor.css";
import Input from "@material-ui/core/Input";
import { makeStyles, withStyles } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

const styles = makeStyles({
  multilineColor: {
    color: "#ffffff",
  },
  label: {
    color: "#ffffff",
  },
  endAdornment: {
    color: "#ffffff",
  },
  underline: {
    color: "#ffff",
  },
});

const WhiteTextField = withStyles({
  underline: {
    "&::before": {
      borderBottom: "1px solid grey",
    },
    "&::after": {
      border: "1px solid white",
    },
  },
})(Input);

const WhiteFormControlLabel = withStyles({
  label: {
    color: "#fff",
  },
})(FormControlLabel);

function TripOptions() {
  const [tripTypeSelectorState, setTripTypeSelectorState] = React.useState({
    roundTrip: false,
    oneWay: true,
  });

  const handleTripTypeChange = (e) => {
    switch (e.target.name) {
      case "roundTrip":
        setTripTypeSelectorState({ roundTrip: true, oneWay: false });
        break;
      case "oneWay":
        setTripTypeSelectorState({ roundTrip: false, oneWay: true });
        break;
      default:
        setTripTypeSelectorState({ roundTrip: false, oneWay: true });
    }
  };
  return (
    <div>
      <div className="doorToDoor-tripOptions">
        <WhiteFormControlLabel
          value="oneway"
          control={
            <Radio
              name="oneWay"
              onChange={handleTripTypeChange}
              checked={tripTypeSelectorState.oneWay}
            />
          }
          label="One Way"
          labelPlacement="start"
        />
        <WhiteFormControlLabel
          value="roundtrip"
          control={
            <Radio
              name="roundTrip"
              onChange={handleTripTypeChange}
              checked={tripTypeSelectorState.roundTrip}
            />
          }
          label="Round Trip"
          labelPlacement="start"
        />
      </div>
    </div>
  );
}

export default TripOptions;
